export function getStoredToken() {
  return localStorage.getItem('token') || '';
}

export function getStoredUsuario() {
  try {
    return JSON.parse(localStorage.getItem('usuario') || 'null');
  } catch {
    return null;
  }
}

export function saveSession(token, usuario) {
  localStorage.setItem('token', token);
  localStorage.setItem('usuario', JSON.stringify(usuario));
}

export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
}

export function createApiFetch(token, onUnauthorized) {
  return async (url, options = {}) => {
    const headers = { ...(options.headers || {}) };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers,
    });

    if (response.status === 401) {
      if (onUnauthorized) onUnauthorized();
      throw new Error('Sua sessão expirou. Faça login novamente.');
    }

    if (response.status === 403) {
      throw new Error('Você não tem permissão para acessar esta funcionalidade.');
    }

    return response;
  };
}

export async function loginRequest(apiBase, email, senha) {
  const response = await fetch(`${apiBase}/usuarios/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, senha }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Erro ao fazer login');
  }

  return data;
}
